<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :append-to-body="true" :close-on-click-modal="false" width="55%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" size="mini" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form">
        <el-tabs>
            <el-tab-pane key="1" label="基础信息">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                        <el-descriptions-item label="轮次" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="roundNo" style="margin-bottom: 0;">
                                <span>{{dataForm.roundNo}}</span>
                                <!-- <el-input v-if="viewFlag !== 'view'" v-model="dataForm.roundNo" placeholder="第几轮报价"></el-input>
                                <span v-else>{{dataForm.roundNo}}</span> -->
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="制造工序名称" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="manufacturingProcess" style="margin-bottom: 0;">
                                <el-input v-if="viewFlag !== 'view'" v-model="dataForm.manufacturingProcess" placeholder="制造工序名称"></el-input>
                                <span v-else>{{dataForm.manufacturingProcess}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="直接人数(A)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="theNumberOfDirect" style="margin-bottom: 0;">
                                <ctl-number :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.theNumberOfDirect" placeholder="直接人数(A)"></ctl-number>
                                <span v-else>{{dataForm.theNumberOfDirect}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="人均劳务费(B)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="perCapitaLaborCosts" style="margin-bottom: 0;">
                                <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.perCapitaLaborCosts" placeholder="人均劳务费(元/小时)(B)"></ctl-number>
                                <span v-else>{{dataForm.perCapitaLaborCosts}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="间接制造人员比例%(C)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="personnelProportion" style="margin-bottom: 0;">
                                <ctl-number :precision="0" :max="100" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.personnelProportion" placeholder="间接制造人员比例%(C)"></ctl-number>
                                <span v-else>{{dataForm.personnelProportion}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="每小时劳务费(D)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="labor" style="margin-bottom: 0;">
                                <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.labor" placeholder="每小时劳务费(元/小时)D=A*B*(1+C)"></ctl-number>
                                <span v-else>{{dataForm.labor}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="投资额(E)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="investment" style="margin-bottom: 0;">
                                <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.investment" placeholder="投资额(E)"></ctl-number>
                                <span v-else>{{dataForm.investment}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="折旧年数(F)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="yearsOfDepreciation" style="margin-bottom: 0;">
                                <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.yearsOfDepreciation" placeholder="折旧年数(F)"></ctl-number>
                                <span v-else>{{dataForm.yearsOfDepreciation}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="每年开工时间(G)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="annualStartTime" style="margin-bottom: 0;">
                                <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.annualStartTime" placeholder="每年开工时间(小时/年)(G)"></ctl-number>
                                <span v-else>{{dataForm.annualStartTime}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="每小时折旧费(H)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="depreciationPerHour" style="margin-bottom: 0;">
                                <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.depreciationPerHour" placeholder="每小时折旧费(元/小时) H=E/(F*G)"></ctl-number>
                                <span v-else>{{dataForm.depreciationPerHour}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="公用动力辅助材料等(I)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="auxiliaryMaterials" style="margin-bottom: 0;">
                                <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.auxiliaryMaterials" placeholder="公用动力辅助材料等(元/小时) (I)"></ctl-number>
                                <span v-else>{{dataForm.auxiliaryMaterials}}</span>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="合计(J)" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="summation" style="margin-bottom: 0;">
                                <!-- TODO：需要联动 -->
                                <span>{{dataForm.summation}}</span>
                                <!-- <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.summation" placeholder="合计(元/小时) J=D+H+I"></ctl-number>
                                <span v-else>{{dataForm.summation}}</span> -->
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-tab-pane>
            <el-tab-pane :key="2" label="辅助材料">
                <el-button size="mini" v-if="isAuth('sourcing:quotation:newbuttonDetail')" class="mb15 fr" type="primary" plain @click="addOrUpdateAuxiliaryMaterials()" icon="el-icon-plus" :disabled="!dataForm.id">
                    新建
                </el-button>
                <el-table :data="dataList" row-key="id" size="mini" border :header-cell-style="{background:'#f5f5f5'}" style="width: 100%;" :default-expand-all="false">
                    <el-table-column type="index" width="50" label="序号">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="item" header-align="center" align="left" label="项目">
                        <template slot-scope="scope">
                            {{ ITEM_VALUE(scope.row.item) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitPrice" header-align="center" align="right" label="单价">
                    </el-table-column>
                    <el-table-column prop="consumption" header-align="center" align="right" label="每小时消耗量">
                    </el-table-column>
                    <el-table-column prop="averageCost" header-align="center" align="right" label="每小时平均成本">
                    </el-table-column>
                    <el-table-column header-align="center" align="left" width="150" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="addOrUpdateAuxiliaryMaterials(scope.row.id)" icon="el-icon-edit">
                                修改
                            </el-button>
                            <el-button type="text" size="small" @click="deleteHandleAuxiliaryMaterials(scope.row.id)" icon="el-icon-delete" class="button-danger">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination @size-change="AuxiliaryMaterialsSizeChangeHandle" @current-change="AuxiliaryMaterialsCurrentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" class="mb15">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="viewData.visible = false">
            取消
        </el-button>
        <el-button size="mini" type="primary" plain @click="dataFormSubmit()">
            提交
        </el-button>
        <!-- <el-button size="mini" type="primary" @click="dataFormSubmit()">
                预览
            </el-button> -->
    </span>
    <div>
        <!-- 弹窗, 新增 / 修改 零件清单 -->
        <add-or-update-AuxiliaryMaterials v-if="addOrUpdateAuxiliaryMaterialsVisible" ref="AddOrUpdatAuxiliaryMaterials" @refreshAuxiliaryMaterialsList="fetchRfqQuotationAuxiliaryMaterials"></add-or-update-AuxiliaryMaterials>
    </div>
</el-dialog>
</template>

<script>
import {
    getRfqQuotationConversionById,
    editRfqQuotationConversion,
    createRfqQuotationConversion,
    fetchRfqQuotationAuxiliaryMaterials,
    removeRfqQuotationAuxiliaryMaterials
} from '@/controller/quotation'
import moment from 'moment'
import AddOrUpdateAuxiliaryMaterials from "./quotationAuxiliaryMaterials-add-or-update";
import {
    getITEM_VALUE,
} from "@/utils/const";
import {
    mapping
} from "@/utils"
import CtlNumber from '@/views/common/ctl-number'
// require('@/mock/mockContract');
export default {
    components: {
        AddOrUpdateAuxiliaryMaterials,
        CtlNumber
    },
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            viewFlag: '',
            dataList: [],
            dataForm: {
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                roundNo: '',
                manufacturingProcess: '',
                theNumberOfDirect: '',
                perCapitaLaborCosts: '',
                personnelProportion: '',
                labor: '',
                investment: '',
                yearsOfDepreciation: '',
                annualStartTime: '',
                depreciationPerHour: '',
                auxiliaryMaterials: '',
                summation: '',
            },
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            ITEM_VALUE: getITEM_VALUE,
            addOrUpdateAuxiliaryMaterialsVisible: false
        }
    },
    mounted() {},
    methods: {
        init(id, viewFlag, data) {
            this.viewFlag = viewFlag
            // this.dataForm = data ? data : this.dataForm
            mapping(data, this.dataForm)
            this.dataForm.id = id || 0;
            this.dataList = [];
            this.viewData.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getRfqQuotationConversionById({}, this.dataForm.id).then(data => {
                        console.log(data)
                        if (data && data.code === '00') {
                            this.dataForm = data.body;
                            // this.dataForm.appartmentCode = data.body.appartmentCode;
                            // this.dataForm.appartmentName = data.body.appartmentName;
                            // this.dataForm.outsourcingSupplier = data.body.outsourcingSupplier;
                            // this.dataForm.supplierId = data.body.supplierId;
                            // this.dataForm.roundNo = data.body.roundNo;
                            // this.dataForm.country = data.body.country;
                            // this.dataForm.unitPrice = data.body.unitPrice;
                            // this.dataForm.quantity = data.boby.quantity;
                            // this.dataForm.summation = data.boby.summation;
                        }
                    });
                    this.fetchRfqQuotationAuxiliaryMaterials();
                }
            })
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    let params = {
                        'id': this.dataForm.id || undefined,
                        'rfqId': this.dataForm.rfqId || undefined,
                        'rfqSupplierId': this.dataForm.rfqSupplierId || undefined,
                        'rfqPartId': this.dataForm.rfqPartId || undefined,
                        'manufacturingProcess': this.dataForm.manufacturingProcess,
                        'roundNo': this.dataForm.roundNo,
                        'theNumberOfDirect': this.dataForm.theNumberOfDirect,
                        'perCapitaLaborCosts': this.dataForm.perCapitaLaborCosts,
                        'personnelProportion': this.dataForm.personnelProportion,
                        'labor': this.dataForm.labor,
                        'investment': this.dataForm.investment,
                        'yearsOfDepreciation': this.dataForm.yearsOfDepreciation,
                        'annualStartTime': this.dataForm.annualStartTime,
                        'depreciationPerHour': this.dataForm.depreciationPerHour,
                        'auxiliaryMaterials': this.dataForm.auxiliaryMaterials,
                        'summation': this.dataForm.summation,
                    }
                    if (this.dataForm.id) {
                        editRfqQuotationConversion(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm = data.body
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createRfqQuotationConversion(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm = data.body
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        // ================== 辅助材料 ===================
        fetchRfqQuotationAuxiliaryMaterials() {
            fetchRfqQuotationAuxiliaryMaterials({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                rfqId: this.dataForm.rfqId,
                rfqSupplierId: this.dataForm.rfqSupplierId,
                rfqPartId: this.dataForm.rfqPartId,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total
                } else {
                    this.dataList = [];
                    this.totalPage = 0
                }
            });
        },
        AuxiliaryMaterialsSizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.fetchRfqQuotationAuxiliaryMaterials()
        },
        // 当前页
        AuxiliaryMaterialsCurrentChangeHandle(val) {
            this.pageIndex = val
            this.fetchRfqQuotationAuxiliaryMaterials()
        },
        // 删除辅助材料数据
        deleteHandleAuxiliaryMaterials(id) {
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    removeRfqQuotationAuxiliaryMaterials({}, id)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.fetchRfqQuotationAuxiliaryMaterials();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});

        },
        //  新增 / 修改 辅助材料
        addOrUpdateAuxiliaryMaterials(id) {
            this.addOrUpdateAuxiliaryMaterialsVisible = true;
            this.$nextTick(() => {
                this.$refs.AddOrUpdatAuxiliaryMaterials.init(id, this.viewFlag, this.dataForm);
            });
        },
        getStyle() {
            return 'width: 240px; text-align: right'
        },
        getStyle2() {
            return 'width: 507.5px;'
        }
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.fr {
    float: right;
}
</style>
